import { Component, OnInit, Input } from '@angular/core';
import { Partner, ImageDescription, PartnerButton } from '@fitscovery/partner/data-access';
import { UtilCustomButtonAlignment } from '../../../../shared/util';

@Component({
  selector: 'fitscovery-ui-groove-section-even',
  templateUrl: './ui-groove-section-even.component.html',
  styleUrls: ['./ui-groove-section-even.component.scss', '../partner-homepage-groove-style.scss']
})
export class UiGrooveSectionEvenComponent implements OnInit {
  @Input() partner: Partner;
  @Input() imageDescription: ImageDescription;

  constructor() { }

  ngOnInit(): void {
  }

  setButtonAlignmentClass(button: PartnerButton): string {
    return UtilCustomButtonAlignment.setButtonAlignment(button)!;
  }

}
